import { ComponentProps } from "react";
import { Colors } from "../../Colors";
import { TextField } from "@mui/material";

export function NumberTextField({
  value,
  onChange,
  sx,
  ...props
}: Omit<ComponentProps<typeof TextField>, "onChange"> & {
  onChange?: (value: number) => void;
}) {
  return (
    <TextField
      type="number"
      sx={{
        width: "80px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "6px",
          background: Colors.textfield
        },
        "& input[type=number]": {
          "-moz-appearance": "textfield", // Firefox
          "&::-webkit-outer-spin-button": {
            "-webkit-appearance": "none", // Chrome, Safari, Edge, Opera
            margin: 0
          },
          "&::-webkit-inner-spin-button": {
            "-webkit-appearance": "none", // Chrome, Safari, Edge, Opera
            margin: 0
          }
        },
        ...sx
      }}
      size={props.size || "small"}
      margin="none"
      value={value}
      onChange={(e) => onChange?.(parseInt(e.target.value))}
      {...props}
    />
  );
}
